<template>
  <div>
    <!--Dialog para confirmação de exclusão-->
    <p-confirm text="Tem certeza que deseja excluir o item de " :entity="translate('table.' + entity + '.title')[1]" :dialog="dialogConfirm" @confirm="deleteItem" @cancel="closeDialogDelete"></p-confirm>
    <!--Index-->
    <v-layout wrap justify-center align-center>
      <v-flex xs12 lg4>
        <span class="headline">{{translate('table.' + entity + '.title')[1]}}</span>
      </v-flex>
      <v-flex xs12 sm6 lg4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 lg4 class="text-xs-right">
        <v-btn color="primary" @click="create" class="mb-4">
          {{this.translate('system.button.add.title')}}
          <v-icon dark> {{this.translate('system.button.add.icon')}}</v-icon>
        </v-btn>
      </v-flex>
      <v-layout row>
        <v-flex xs12>
          <v-data-table
          :no-data-text="emptyTable"
          rows-per-page-text="Registros por página"
          :headers="headers"
          :items="items"
          :search="search"
          :rows-per-page-items="[10,20,30,{'text':'Todos','value':-1}]"
          class="elevation-1"
          :custom-filter="customizedFilter"  style="word-break: break-all;">
            <template slot="items" slot-scope="props">
              <td>{{ props.item.id_text }}</td>
              <td align="center">
                <v-btn icon class="mx-0" @click="editItem(props.item)">
                  <v-icon color="teal">edit</v-icon>
                </v-btn>
                <v-btn icon class="mx-0" @click="dialogDelete(props.item)">
                  <v-icon color="pink">delete</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-layout>
    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="900px" height="100%" persistent scrollable :fullscreen="$vuetify.breakpoint.smAndDown" v-resize="onResizePreview">
      <v-card height="90vh">
        <v-card-title primary-title style="padding-top: 0px;padding-bottom: 0px;height: 65px;">
          <v-layout wrap justify-space-between align-center>
            <v-flex grow>
              <span class="headline">{{this.editMode ? 'Modo de edição' : 'Pre-visualização'}}</span>
            </v-flex>
            <v-flex grow>
              <v-btn v-if="$vuetify.breakpoint.smAndDown" outline fab @click="editMode ? clickPreviewMode() : clickEditMode()">
                <v-icon color="black">{{this.editMode ? 'visibility' : 'edit'}}</v-icon>
              </v-btn>
              <v-btn v-else outline @click="editMode ? clickPreviewMode() : clickEditMode()">
                <v-icon color="black">{{this.editMode ? 'visibility' : 'edit'}}</v-icon>{{this.editMode ? 'Pre-visualização' : 'Modo de Edição'}}
              </v-btn>
            </v-flex>
            <v-flex shrink>
              <v-btn icon fab @click="close()">
                <v-icon color="black">close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="padding: 0px;height:100%">
          <v-form v-model="valid" style="height:100%" @keyup.native.esc="close()" @keyup.native.ctrl.enter="saveDocument()" ref="form">
            <v-layout wrap justify-center align-center>
              <v-text-field v-if="editMode" class="mx-2" maxlength="190" counter="190"  ref="autofocus" :label="translate('table.' + entity + '.field.id_text')" :rules="requiredRule(translate('table.' + entity + '.field.id_text'))" v-model="editedItem['id_text']"></v-text-field>
              <!-- // no p-text-editor foi usado o v-show pois com o v-if ficava desformatando pois ai tirar o texteditor ficava um campo do antigo -->
              <div v-show="editMode">
                <p-text-editor ref="textEditor" @change="(val) => {editedItem['description'] = val}" :width="$vuetify.breakpoint.smAndDown ? null : '805.70px'" :height="'90%'"></p-text-editor>
              </div>
              <!-- no vue-document-editor foi usado o v-if pois com o v-show o v-text-field so aceitava 1 caracter -->
              <vue-document-editor v-if="!editMode" :content="[editedItem['description']]" @update:content="(val) => editedItem['description'] = val[0]" :display="display"
              :zoom="zoom"
              :page_format_mm="page_format_mm"
              :page_margins="page_margins"/>
              <!-- :overlay="overlay"  -->
            </v-layout>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" color="primary darken-2" :loading="loading" @click.native="saveDocument()">Salvar</v-btn>
          <v-btn class="mx-0" @click.native="close()">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style>
  .menu_content {
    padding: 0 10px 10px 10px;
  }
</style>

<script>
  /* eslint-disable no-undef */
  import crud from './../../mixin/crud'
  import rules from './../../mixin/rules'
  import imageCompress from '../../mixin/imageCompress'
  import PTextEditor from './../shared/PTextEditor'
  import PConfirm from './../shared/PConfirm'

  export default {
    mixins: [crud, rules, imageCompress],
    components: {
      PConfirm, PTextEditor, VueDocumentEditor
    },
    name: 'Document',
    props: {
      tasktemplate: {
        type: Object,
        default: function () { return {} }
      }
    },
    data: () => ({
      entity: 'tasktemplate_document',
      search: '',
      fab: null,
      editMode: true,
      zoom: 1.0,
      page_format_mm: [210, 297],
      page_margins: '25mm 30mm 25mm 30mm',
      display: 'grid',
      img: ''
    }),
    created () {
      this.items = this.tasktemplate['documents'] ? this.tasktemplate['documents'] : []
      this.editedItem = {tasktemplate_id: this.tasktemplate.id, id_text: '', description: ''}
      this.defaultItem = {tasktemplate_id: this.tasktemplate.id, id_text: '', description: ''}
    },
    mounted: function () {
      this.$emit('itemsLength', this.items.length)
      // expande as opções do componente de texto
      this.$refs.textEditor.textToolExp = true
    },
    methods: {
      afterCreate () {
        this.editMode = true
        this.getCustomFields()
        this.$refs.textEditor.refresh(500)
        let randowId = this.$refs.textEditor.getRandowId()
        // insere margem no campo de documento para ficar com as msm margens do componente de documento
        document.getElementById('rteObj' + randowId + '_rte-edit-view').style.padding = this.page_margins
      },
      afterEditItem () {
        this.editMode = true
        this.getCustomFields()
        this.$refs.textEditor.setValue(this.editedItem.description)
        this.$refs.textEditor.refresh()
        let randowId = this.$refs.textEditor.getRandowId()
        // insere margem no campo de documento para ficar com as msm margens do componente de documento
        document.getElementById('rteObj' + randowId + '_rte-edit-view').style.padding = this.page_margins
      },
      afterDelete (res) {
        this.$emit('itemsLength', this.items.length)
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'documents',
          responseEvent: 'deleteSocketDetails',
          room: `tasktemplates` + this.$auth.user().company_id + `_` + this.tasktemplate.id
        })
      },
      afterEditValue (res) {
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'documents',
          responseEvent: 'editSocketDetails',
          room: `tasktemplates` + this.$auth.user().company_id + `_` + this.tasktemplate.id
        })
      },
      afterInsert (res) {
        this.$emit('itemsLength', this.items.length)
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'documents',
          responseEvent: 'addSocketDetails',
          room: `tasktemplates` + this.$auth.user().company_id + `_` + this.tasktemplate.id
        })
      },
      afterUpdate (res) {
        this.$socket.emit('generalDetailsEvent', {
          data: res,
          details: 'documents',
          responseEvent: 'editSocketDetails',
          room: `tasktemplates` + this.$auth.user().company_id + `_` + this.tasktemplate.id
        })
      },
      clickEditMode () {
        this.editMode = true
        this.$refs.textEditor.setValue(this.editedItem.description)
        this.$refs.textEditorPreview.refresh()
      },
      close () {
        this.editMode = true
        this.$refs.textEditor.setValue('')
        this.editedItem = Object.assign(JSON.parse(JSON.stringify(this.defaultItem)), {})
        this.dialog = false
      },
      onResizePreview () {
        // faz calculo para saber o tamanho do documento para ficar ajustado em telas menores como no mobile
        let widthWindow = window.innerWidth || document.body.clientWidth
        console.log('widthWindow', widthWindow)
        if (widthWindow >= 850) {
          this.zoom = 1.00
        } else {
          this.zoom = widthWindow / 870
        }
      },
      clickPreviewMode () {
        this.editMode = false
      },
      saveDocument () {
        this.$store.commit('loader/change_dialog', true)
        // this.editedItem.description = this.$refs.textEditor.getValue()
        // convertido o comentario agora para base64 para armazenagem no servidor
        this.imgsCompressAndBase64(this.editedItem.description).then(res => {
          this.$store.commit('loader/change_dialog', false)
          this.editedItem.description = res
          this.save()
        }, err => {
          console.log(err)
          this.$store.commit('snackbar/change_values', {
            text: 'Erro ao salvar listagem!',
            color: 'error',
            dialog: true
          })
        })
      },
      getCustomFields () {
        let customFields = this.$store.state.customField.values
        // insere os campos padroes
        let fields = JSON.parse(JSON.stringify(this.translate('value.tasktemplate_document')))
        // insere os campos personalizados
        customFields.map((val) => fields.push({ id: val['id'], title: val['title'], category: 'custom_field', type: val['type'] }))
        // inclui algumas propriedades para serem usadss no tribute
        fields.map((field) => {
          let categoryText = field['category'] === 'field_client' ? 'Cliente' : (field['category'] === 'custom_field' ? 'Campo personalizado' : (field['category'] === 'other_field' ? 'Outros Campos' : 'Tarefa'))
          field['categoryText'] = categoryText
          field['filterText'] = (categoryText + ' ' + field['title'])
        })
        setTimeout(() => {
          this.$refs.textEditor.createDocument(fields)
        }, 100)
      },
      overlay (page, total) {
        // Add page numbers on each page
        let html = '<div style="position: absolute; bottom: 8mm; right: 10mm">Página ' + page + ' de ' + total + '</div>'
        return html
      }
    },
    computed: {
      headers: function () {
        return [
          {text: this.translate('table.' + this.entity + '.field.id_text'), value: 'id_text', width: '80%'},
          {text: this.translate('system.table.action'), value: 'action', sortable: false, align: 'center'}
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/details/TemplateDocument.vue